jQuery(function($) {

  let focusable = jQuery('button, a:not(.ctct-button), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');
  let hsh = window.location.hash;

  function change() {
    hsh = window.location.hash;
    jQuery(hsh).on('keyup', function(e) {
      if (e.key === 'Escape') {
        location.hash = '#_';
      }
    });
  }

  jQuery('.skip').on('keydown', function(e) {
    if (window.location.hash.length > 2 && e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      jQuery(window.location.hash + ':target').find(focusable).first().focus();
    }
  });

  change();

  jQuery(window).on('hashchange', function(e) {
    change();
  });

  jQuery(hsh).find(focusable).first().on('keydown', function(e) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      jQuery(hsh).find('[href="#_"]').focus();
    }
  });

  jQuery('dialog').find(focusable).first().on('keydown', function(e) {
    if (e.key === 'Tab' && e.shiftKey) {
      e.preventDefault();
      jQuery(this).parents('dialog').find('form[method="dialog"] button').focus();
    }
  });

  jQuery('[href="#_"]').on('keydown', function(e) {
    if (e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      jQuery('dialog:target').find(focusable).first().focus();
    }
  });

  jQuery('form[method="dialog"] button').on('keydown', function(e) {
    if (e.key === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      jQuery(this).parents('dialog').find(focusable).first().focus();
    }
  });
});
